
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 0a8.936 8.936 0 00-5.786 2.134V.643a.643.643 0 00-1.285 0v3.214a.643.643 0 00.642.643h3.215a.643.643 0 100-1.286H3.928A7.63 7.63 0 019 1.286a7.714 7.714 0 11-7.502 5.933.643.643 0 10-1.247-.295A8.82 8.82 0 000 9a9 9 0 109-9z"}})])
          )
        }
      }
    